import inputData from './inputData/trivia-quiz';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'trivia-quiz',
  title: 'Trivia Quiz',
  description: 'Engage your audience with a fun, interactive quiz that scores answers in real time.',
  image: '/images/templates/trivia-quiz.png',
  tags: ['engage-audience', 'human-resources', 'recruit-talent'],
  inputData: inputData,
  popular: true,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

